export default function PtzController({
  funcPtz,
  funcSnapshot,
}: {
  funcPtz: (cmd: string) => void;
  funcSnapshot: () => void;
}) {
  return (
    <svg
      version="1.1"
      id="menu"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
    >
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("Up")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M62.9,49.8c2.8-1.1,5.9-1.8,9.1-1.8c3.2,0,6.3,0.6,9.1,1.8L99.5,5.4C91,1.9,81.7,0,72,0
		c-9.7,0-19,1.9-27.5,5.4L62.9,49.8z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300"
          //
          //stroke="#ffffff"
        />
        <path
          d="M72.6,18.8l4.1,10c0.2,0.6-0.3,1.1-0.9,0.9L72.3,28c-0.2-0.1-0.4-0.1-0.5,0l-3.6,1.6c-0.5,0.2-1.1-0.3-0.9-0.9
		l4.1-10C71.6,18.2,72.4,18.2,72.6,18.8z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("UpRight")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M81.3,49.9c5.8,2.4,10.4,7.1,12.9,12.9l44.4-18.4c-7.3-17.5-21.3-31.5-38.8-38.8L81.3,49.9z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300"
        />
        <path
          d="M110.1,34.8l-4.2,10c-0.2,0.6-1,0.5-1.2,0l-1.4-3.6c-0.1-0.2-0.2-0.3-0.4-0.4l-3.6-1.4c-0.6-0.2-0.6-1,0-1.2
		l10-4.2C109.8,33.7,110.3,34.2,110.1,34.8z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("Right")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M96,72c0,3.2-0.6,6.3-1.8,9.1l44.4,18.4C142.1,91,144,81.7,144,72c0-9.7-1.9-19-5.4-27.5L94.2,62.9
		C95.4,65.7,96,68.8,96,72z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300"
        />
        <path
          d="M125.2,72.6l-10,4.1c-0.6,0.2-1.1-0.3-0.9-0.9l1.6-3.6c0.1-0.2,0.1-0.4,0-0.5l-1.6-3.6
		c-0.2-0.5,0.3-1.1,0.9-0.9l10,4.1C125.8,71.6,125.8,72.4,125.2,72.6z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("DownRight")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M94.1,81.3c-2.4,5.8-7.1,10.4-12.9,12.9l18.4,44.4c17.5-7.3,31.5-21.3,38.8-38.8L94.1,81.3z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300"
        />
        <path
          d="M109.2,110.1l-10-4.2c-0.6-0.2-0.5-1,0-1.2l3.6-1.4c0.2-0.1,0.3-0.2,0.4-0.4l1.4-3.6c0.2-0.6,1-0.6,1.2,0
		l4.2,10C110.3,109.8,109.8,110.3,109.2,110.1z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("Down")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M81.1,94.2C78.3,95.4,75.2,96,72,96c-3.2,0-6.3-0.6-9.1-1.8l-18.4,44.4C53,142.1,62.3,144,72,144
		c9.7,0,19-1.9,27.5-5.4L81.1,94.2z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300 "
        />
        <path
          d="M71.4,125.2l-4.1-10c-0.2-0.6,0.3-1.1,0.9-0.9l3.6,1.6c0.2,0.1,0.4,0.1,0.5,0l3.6-1.6c0.5-0.2,1.1,0.3,0.9,0.9
		l-4.1,10C72.4,125.8,71.6,125.8,71.4,125.2z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("DownLeft")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M62.7,94.1c-5.8-2.4-10.4-7.1-12.9-12.9L5.5,99.6c7.3,17.5,21.3,31.5,38.8,38.8L62.7,94.1z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300"
        />
        <path
          d="M33.9,109.2l4.2-10c0.2-0.6,1-0.5,1.2,0l1.4,3.6c0.1,0.2,0.2,0.3,0.4,0.4l3.6,1.4c0.6,0.2,0.6,1,0,1.2l-10,4.2
		C34.2,110.3,33.7,109.8,33.9,109.2z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("Left")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M48,72c0-3.2,0.6-6.3,1.8-9.1L5.4,44.5C1.9,53,0,62.3,0,72c0,9.7,1.9,19,5.4,27.5l44.4-18.4
		C48.6,78.3,48,75.2,48,72z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300"
        />
        <path
          d="M18.8,71.4l10-4.1c0.6-0.2,1.1,0.3,0.9,0.9L28,71.7c-0.1,0.2-0.1,0.4,0,0.5l1.6,3.6c0.2,0.5-0.3,1.1-0.9,0.9
		l-10-4.1C18.2,72.4,18.2,71.6,18.8,71.4z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcPtz("UpLeft")}
        onMouseUp={() => funcPtz("Stop")}
        onMouseLeave={() => funcPtz("Stop")}
      >
        <path
          d="M49.9,62.7c2.4-5.8,7.1-10.4,12.9-12.9L44.4,5.5C26.8,12.8,12.8,26.8,5.5,44.4L49.9,62.7z"
          className="fill-white opacity-50 group-hover/ptz-piece:fill-neutral-300"
          fill="#ffffff"
        />
        <path
          d="M34.8,33.9l10,4.2c0.6,0.2,0.5,1,0,1.2l-3.6,1.4c-0.2,0.1-0.3,0.2-0.4,0.4l-1.4,3.6c-0.2,0.6-1,0.6-1.2,0
		l-4.2-10C33.7,34.2,34.2,33.7,34.8,33.9z"
          className="fill-neutral-700"
        />
      </g>
      <g
        className="group/ptz-piece cursor-pointer"
        onMouseDown={() => funcSnapshot()}
      >
        <circle
          cx="72"
          cy="72"
          r="23.8"
          className="fill-white fill-opacity-50 group-hover/ptz-piece:fill-neutral-300"
          stroke="#E1E1E1"
        />
        <g fill="#E1E1E1">
          <circle cx="72" cy="73" r="3" className="fill-neutral-700" />
          <path
            d="M80,65h-3.2l-1.2-1.3c-0.4-0.4-0.9-0.7-1.5-0.7h-4.2c-0.6,0-1.1,0.2-1.5,0.7L67.2,65H64c-1.1,0-2,0.9-2,2v12
			c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V67C82,65.9,81.1,65,80,65z M72,78c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S74.8,78,72,78z"
            className="fill-neutral-700"
          />
        </g>
      </g>

      <g className="group/ptz-piece cursor-pointer">
        <circle
          cx="72"
          cy="72"
          r="72"
          className="fill-transparent pointer-events-none"
          stroke="#E1E1E1"
        />
      </g>
    </svg>
  );
}
